export const animationSettings = {
  '15fslogo': {
    'default': ['static'],
    'STATE:IN:FS-START': ['play', true],
    'STATE:OUT:FS-START': ['static'],
  },
  'bird': {
    'default': ['static'],
    'BONUS-MULTIPLIER-ANIM': ['play', false],
    'RESIZE': ['stop'],
  },
}
